<app-consent-banner #consentBanner (closeBanner)="onConsentBannerClosed()"></app-consent-banner>
<app-shell></app-shell>
<span class="consent-management" *ngIf="showConsentButton" (click)="openConsentBanner()">Gerir o Consentimento</span>
